import React from 'react';
import classNames from 'classnames/bind';
import { Ellipsis } from "./Ellipsis";
import { Item } from "./Item";
import { Next } from "./Next";
import { Prev } from "./Prev";
import { DOTS } from "../constants";
import { FieldInput, FieldRoot } from "../../internal/Field";
import styles from "../PageNavigator.css";
var cx = classNames.bind(styles);
export var Pages = function Pages(_ref) {
  var paginationRange = _ref.paginationRange,
      handleKeyPress = _ref.handleKeyPress,
      handleBlur = _ref.handleBlur,
      pagesFieldClassName = _ref.pagesFieldClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('pages')
  }, /*#__PURE__*/React.createElement(Prev, null), paginationRange === null || paginationRange === void 0 ? void 0 : paginationRange.map(function (item, index) {
    if (item === DOTS) {
      // eslint-disable-next-line react/no-array-index-key
      return /*#__PURE__*/React.createElement(Ellipsis, {
        key: index
      });
    } // eslint-disable-next-line react/no-array-index-key


    return /*#__PURE__*/React.createElement(Item, {
      page: item,
      key: index
    });
  }), /*#__PURE__*/React.createElement(Next, null), /*#__PURE__*/React.createElement(FieldRoot, {
    size: "small",
    classes: {
      root: cx('fieldRoot', pagesFieldClassName)
    }
  }, /*#__PURE__*/React.createElement(FieldInput, {
    placeholder: "\u2116",
    type: "number",
    classes: {
      input: cx('fieldInput')
    },
    onKeyPress: handleKeyPress,
    onBlur: handleBlur
  })));
};